module.exports = __webpack_public_path__ + "7a3a46682602bda4ee003879d8f8ba37.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-768.webp
// module id = 218
// module chunks = 0